<template>
  <v-col class="mt-2">
    <v-layout>
      <v-flex pl-3 xs12 md12 lg12 xl12 pb-2>
        <SimpleCard v-if="!loadingDriver && driver">
          <v-col justify-center>
            <v-flex>
              <v-layout row wrap align-content-center justify-center>
                <v-flex v-if="loadingDriver" xs12 pa-1 class="text-xs-center">
                  <v-progress-circular
                    :size="48"
                    :width="5"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </v-flex>
                <Driver :driver="driver"></Driver>
              </v-layout>
            </v-flex>
          </v-col>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-col>
</template>

<script>
import Stat from "@/components/widget/Stat.vue";
import SimpleCard from "@/components/widget/SimpleCard.vue";
import DriverList from "@/components/driver/DriverList.vue";
import DriverSearchBox from "@/components/driver/DriverSearchBox.vue";
import Driver from "@/views/driver/Driver.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "DriverDetails",
  components: {
    SimpleCard,
    DriverList,
    DriverSearchBox,
    Driver,
  },

  data: function () {
    return {
      driver: null,
      drivers: [],
      bookings: [],
      offset: 0,
      count: 20,
      query: {
        search: "",
        rideType: [],
        lockedOut: false,
        plannerFilter: "filter_all",
      },
      loading: true,
      loadingDriver: false,
      pagination: { page: 1 },
      num_pages: 0,
      noMoreResults: false,
      driverStats: null,
    };
  },
  mounted: async function () {
    this.getDriver((this.$route.params.id));
  },
  methods: {
    search: function () {
      this.pagination.page = 1;
      this.noMoreResults = false;
      this.getDrivers();
    },
    clear: function () {
      this.query = {
        search: "",
        lockedOut: false,
      };
    },
    changePage: function (page) {
      this.pagination.page = page;
      this.getDrivers();
    },
    getDrivers: async function () {
      this.loading = true;

      try {
        let queryRideType =
          this.query.rideType == "" ? -1 : this.query.rideType;

        var url = `${this.$store.state.apiUrl}/driverPlanner/list?offset=${
          this.count * (this.pagination.page - 1)
        }&count=${this.count}&filter=${this.query.plannerFilter}`;

        if (this.query.rideType.length > 0) {
          for (var i = 0; i < this.query.rideType.length; i++) {
            url += `&rideType=${this.query.rideType[i]}`;
          }
        }

        url += `&lockedOut=${this.query.lockedOut}`;

        url += `&query=${this.query.search}`;

        let response = await axios.get(url, {
          params: {},
        });

        console.log(response.data);

        if (response.data.error != null) {
          if (response.data.error == "no_results") {
            this.noMoreResults = true;
          } else {
            this.noMoreResults = false;
          }
        }

        var drivers = response.data.drivers;
        drivers.forEach(driver => {
          if (driver.breaks) {
            console.log(driver)
          }
          if (driver.daysOff) {
            console.log(driver)
          }
        })

        if (drivers != null && drivers.length < this.count) {
          this.noMoreResults = true;
        } else if (drivers != null && drivers.length == this.count) {
          this.noMoreResults = false;
        }

        this.drivers = drivers;

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get drivers " + error);
      }
    },
    getDriver: async function (id) {
      this.loadingDriver = true;
      this.driver = null;

      try {
        var url = `${this.$store.state.apiUrl}/driver/${id}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        this.driver = response.data;

        this.loadingDriver = false;
      } catch (error) {
        this.loadingDriver = false;
        console.log("Failed to get driver " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>


<style  lang="scss">
.driverNavigation {
  padding-left: 12px;
  padding-right: 12px;
  color: #999fb8 !important;
}
</style>
